"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@/lib/utils"

type LabelSize = "sm" | "md"

const sizeClassMap: Record<LabelSize, string> = {
  sm: "body-sm",
  md: "body-md",
}

interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  size?: LabelSize
}

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, size = "md", ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(sizeClassMap[size], className)}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
export type { LabelSize, LabelProps }
